<template>
  <v-card>
    <v-card-text>
      <!-- <math-editor v-if="mathQuiz" v-model="text" @change="(text) => $emit('change', { ...question, text })"></math-editor> -->
      <v-row>
        <v-col cols="12">
            <h4>Text to put above question (leave blank for none)</h4>
            <html-editor v-model="text" @change="(text) => $emit('change', { ...question, text })"></html-editor>
        </v-col>
        <v-col cols="12" md="9">
          <v-text-field v-model="label" label="Question" @change="(label) => $emit('change', { ...question, label })"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-select v-model="type" :items="typeOptions" label="Input Type" @change="(type) => $emit('change', { ...question, type })"></v-select>
        </v-col>
      </v-row>
      <v-text-field
        v-for="(answer, index) in answers"
        :key="'option-' + index"
        :value="answer.text"
        :label="'Answer ' + (index + 1)"
        hide-details
        dense
        outlined
        @change="(val) => updateAnswer(index, 'text', val)"
        style="margin-bottom:.3em">
        <template v-slot:prepend>
          <v-dialog width="400">
            <template v-slot:activator="{ on: dialogOn }">
              <v-tooltip top>
                <template v-slot:activator="{ on: tooltipOn }">
                  <v-btn v-on="{ ...dialogOn, ...tooltipOn }" :color="answer.response === '' ? '' : 'info'" icon>
                    <v-icon>{{ answer.response === '' ? 'fal fa-comment-alt' : 'fas fa-comment-alt-lines' }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ answer.response === '' ? 'Set' : 'Edit' }} response text for if the student chooses this answer</span>
              </v-tooltip>
            </template>
            <v-card>
              <v-card-title>{{ correctAnswer === index ? 'Correct Answer' : 'Incorrect Answer' }}</v-card-title>
              <math-editor v-if="mathQuiz" :value="answer.response" @input="(val) => updateAnswer(index, 'response', val)"></math-editor>
              <html-editor v-else :value="answer.response" @input="(val) => updateAnswer(index, 'response', val)"></html-editor>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:append>
          <v-tooltip v-if="correctAnswer === index" top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="success" icon>
                <v-icon>fas fa-check</v-icon>
              </v-btn>
            </template>
            <span>This is currently set as the correct answer</span>
          </v-tooltip>
          <v-tooltip v-else top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="correctAnswer = index">
                <v-icon>fal fa-check</v-icon>
              </v-btn>
            </template>
            <span>Set this answer as the correct answer.</span>
          </v-tooltip>
        </template>
        <template v-slot:append-outer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="error" icon @click="removeAnswer(index)">
                <v-icon>fas fa-times-circle</v-icon>
              </v-btn>
            </template>
            <span>Remove answer</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="addAnswer">Add Answer</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="error" text @click="$emit('remove')">Remove Question</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { ref, watch } from '@vue/composition-api'
export default {
  components: {
    MathEditor: () => import('@/components/forms/MathEditor'),
    HtmlEditor: () => import('@/components/forms/HTMLEditor')
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    mathQuiz: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const text = ref(props.question.text || '')
    const label = ref(props.question.label || '')
    const type = ref(props.question.type || 'Radio')
    const correctAnswer = ref(props.question.correctAnswer || null)
    const answers = ref(props.question.answers || [])
    const typeOptions = ref([
      { text: 'Radio Input', value: 'Radio' },
      { text: 'Select Box', value: 'Select' },
      { text: 'Autocomplete', value: 'Autocomplete' }
    ])

    watch(() => props.question, () => {
      if (props.question.text !== text.value) text.value = props.question.text
      if (props.question.label !== label.value) label.value = props.question.label
      if (props.question.type !== type.value) type.value = props.question.type
      if (props.question.correctAnswer !== correctAnswer.value) correctAnswer.value = props.question.correctAnswer
      if (JSON.stringify(props.question.answers) !== JSON.stringify(answers.value)) answers.value = props.question.answers
    })

    watch([text, label, type, answers, correctAnswer], () => {
      emit('change', { text: text.value, label: label.value, type: type.value, correctAnswer: correctAnswer.value, answers: answers.value })
    })

    function addAnswer () {
      answers.value.push({ text: '', response: '' })
    }

    function updateAnswer (index, field, val) {
      let temp = Object.assign({}, answers.value[index])
      if (field === 'response' && val === '<p></p>') val = ''
      temp[field] = val
      answers.value.splice(index, 1, temp)
    }

    function removeAnswer (index) {
      answers.value.splice(index, 1)
    }

    const formula = ref('')

    return {
      text,
      label,
      type,
      correctAnswer,
      answers,
      typeOptions,
      addAnswer,
      updateAnswer,
      removeAnswer,
      formula
    }
  }
}
</script>
